module.exports = __webpack_public_path__ + "img/login-bg.b463a2d3.jpg";